<div class="layout-column"
     [ngClass]="size">

  <app-user-avatar *ngIf="!doUpload && (agent || agentReference)"
                   [url]="agent.user?.avatarUrl || agentReference?.avatarUrl"
                   [user]="agent.user || agentReference"
                   [size]="size">
  </app-user-avatar>

  <app-user-avatar *ngIf="doUpload && (agent || agentReference)"
                   [url]="agent.user?.avatarUrl || agentReference?.avatarUrl"
                   [user]="agent.user || agentReference"
                   [size]="size">
  </app-user-avatar>

  <div *ngIf="!hideStatus && !!hideTaskCount"
       class="status-container text-center small"
       [ngClass]="agent?.status || agentReference?.status">
  </div>

  <div *ngIf="!hideStatus && !hideTaskCount"
       class="status-container text-center"
       [ngClass]="agent?.status || agentReference?.status">
    <span>{{agent.itineraryInfo?.numberOfTasks > 0 ? agent.itineraryInfo.numberOfTasks : ''}}</span>
  </div>

</div>
